import React, { useState } from "react";
import { Button, Header, Dropdown, Input } from "@fluentui/react-northstar";
import { useIntl } from "react-intl";
import { useHistory, useParams } from "react-router-dom";
import Axios from "axios";
import { useLocation } from "react-router-dom";
import { confirmAlert } from "react-confirm-alert";
import { authContext } from "../../auth";
import {
  UpdateAgentProfileManagementURL,
  AddAgentProfileManagementUrl
} from "../../urls";
import "../Agent/agentComponent.css";

const AgentProfileComponent = (props) => {
  const params = useParams();
  const intl = useIntl();
  const location = useLocation();
  const history = useHistory();
  const profile = location.state?.agentProfile; //  récupération ici


  // 🔹 Initialisation du profil agent à partir des props
  const [agentProfile, setAgentProfile] = useState(
    profile || {
      displayName: "",
      region: "",
    }
  );

  // 🔹 Liste des régions avec traduction dynamique
  const RegionsList = [
    { header: intl.formatMessage({ id: "Europe" }), value: "EU" },
    { header: intl.formatMessage({ id: "America" }), value: "AMER" },
    { header: intl.formatMessage({ id: "AsiaPacific" }), value: "APAC" },
  ];

 
  const addNewAgentProfile = () => {
   
    if (agentProfile.displayName === "" || agentProfile.region === "") {
      confirmAlert({
        title: intl.formatMessage({ id: "Error" }),
        message: intl.formatMessage({
          id: "ADD_AGENT_PROFILE_ERROR",
        }),
        buttons: [{ label: "Ok" }],
      });
      return;
    }
    const isDuplicate = Object.values(props.AgentsProfilesList).some(
      (agent) =>
        agent.displayName.trim().toLowerCase() ===
        agentProfile.displayName.trim().toLowerCase()
    );
  
    if (isDuplicate) {
      confirmAlert({
        title: intl.formatMessage({ id: "Error" }),
        message: intl.formatMessage({
          id: "AgentNameMustBeUnique",
          defaultMessage: "The agent profile name must be unique",
        }),
        buttons: [{ label: "Ok" }],
      });
      return;
    }
    const url = AddAgentProfileManagementUrl(authContext._user.profile.tid); 
    Axios.post(url, agentProfile)
      .then((response) => {
        if (response.data.message === "added" && response.status === 200) {
          const newAgentProfile = response.data.data; // contient tout l'objet

       
        const updatedListProfile = {
          ...props.AgentsProfilesList,           
          [newAgentProfile.id]: newAgentProfile, 
        };  
         props.setAgentsProfilesList(updatedListProfile);
        
          history.push("/agentsProfiles");
        }
        
      })
      .catch((error) => {
        console.log("Add error:", error.response?.data || error.message);
      
      });
  };

  // Mise à jour du profil agent
  const updateAgentProfile = () => {

   
    const url = UpdateAgentProfileManagementURL(
      authContext._user.profile.tid,
      agentProfile.id
    );

    Axios.put(url, agentProfile)
      .then((response) => {
    
        if (response.data.message === "updated" && response.status === 200) {
          const updatedListProfile = {
            ...props.AgentsProfilesList,
            [agentProfile.id]: agentProfile, // utilise l'objet local mis à jour
          };
          props.setAgentsProfilesList(updatedListProfile);
          history.push("/agentsProfiles");
        }else {
          console.log("update échouée pour :", agentProfile.id);
        }
      })
      .catch((error) => {
        console.log("Update error:", error);
      });
  };

  return (
    <div id="agent-div">
      <Button
        content={intl.formatMessage({ id: "save" })}
        primary
        onClick={() => {
          if (params.id === "newAgentProfile") {
            addNewAgentProfile();
          } else {
            updateAgentProfile();
          }
        }}
        id="submit-button-agent"
      />

      {/* Nom du profil */}
      <div className="agent-name-div">
        <Header
          as="h4"
          content={intl.formatMessage({ id: "AGENT_PROFILE_NAME" })}
          className="label-form_queue"
        />
        <Input
          placeholder={intl.formatMessage({ id: "AGENT_PROFILE_NAME" })}
          className="from-item"
          value={agentProfile.displayName}
          onChange={(e, data) =>
            setAgentProfile({ ...agentProfile, displayName: data.value })
          }
          required
        />
      </div>

      {/* Région */}
      <div className="agent-scope-div">
        <Header
          as="h4"
          content={intl.formatMessage({ id: "AGENT_PROFILE_REGION" })}
          className="label-form_queue"
        />
        <Dropdown
          placeholder={intl.formatMessage({ id: "AGENT_PROFILE_REGION" })}
          items={RegionsList} // [{ header, value }]
          value={
            RegionsList.find((r) => r.value === agentProfile.region)?.header
          }
          onChange={(e, data) => {
            setAgentProfile({
              ...agentProfile,
              region: data.value.value,
            });
          }}
        />
      </div>
    </div>
  );
};

export default AgentProfileComponent;
